import axios from 'axios';
import { INoteCollectionDto, INoteCollectionParams, INoteCreatePayload, INoteDto } from 'app/models/note.models';

const basePath = '/notes';

export const noteService = {
  getNotes: (params: INoteCollectionParams): Promise<INoteCollectionDto> => axios.get(`${basePath}`, { params }),
  createNote: (payload: INoteCreatePayload): Promise<INoteDto> => axios.post(`${basePath}`, payload),
};
